/**
 * Router hash-based simple pour GroceWise.
 */

/**
 * Change la route en modifiant le hash.
 * @param {string} path - Chemin sans le # (ex: '/', '/store/1')
 */
export function navigate(path) {
  const normalized = path.startsWith('#') ? path.slice(1) : path;
  const target = normalized.startsWith('/') ? normalized : `/${normalized}`;
  window.location.hash = target;
}

/**
 * Parse le hash actuel et retourne la route correspondante.
 * @returns {{ path: string, params: { id?: number } }}
 */
export function getCurrentRoute() {
  let hash = window.location.hash.slice(1);

  if (!hash || hash === '/') {
    return { path: '/', params: {} };
  }

  // /store/:id/settings
  const settingsMatch = hash.match(/^\/store\/(\d+)\/settings$/);
  if (settingsMatch) {
    return { path: '/store/:id/settings', params: { id: Number(settingsMatch[1]) } };
  }

  // /store/:id/shopping
  const shoppingMatch = hash.match(/^\/store\/(\d+)\/shopping$/);
  if (shoppingMatch) {
    return { path: '/store/:id/shopping', params: { id: Number(shoppingMatch[1]) } };
  }

  // /store/:id
  const storeMatch = hash.match(/^\/store\/(\d+)$/);
  if (storeMatch) {
    return { path: '/store/:id', params: { id: Number(storeMatch[1]) } };
  }

  // /quick-list
  if (hash === '/quick-list') {
    return { path: '/quick-list', params: {} };
  }

  // /community
  if (hash === '/community') {
    return { path: '/community', params: {} };
  }

  // /login
  if (hash === '/login' || hash.startsWith('/login?')) {
    return { path: '/login', params: {} };
  }

  // /join/:code
  const joinMatch = hash.match(/^\/join\/([A-Za-z0-9]+)$/);
  if (joinMatch) {
    return { path: '/join/:code', params: { code: joinMatch[1].toUpperCase() } };
  }

  // /account
  if (hash === '/account') {
    return { path: '/account', params: {} };
  }

  // Route inconnue
  return { path: 'unknown', params: {} };
}

/**
 * Initialise le router et appelle onRouteChange à chaque changement de hash.
 * @param {(route: { path: string, params: { id?: number } }) => void} onRouteChange
 */
export function initRouter(onRouteChange) {
  const handleRoute = () => {
    onRouteChange(getCurrentRoute());
  };

  window.addEventListener('hashchange', handleRoute);
  handleRoute();
}
